module.exports = __webpack_public_path__ + "static/media/1.744acd53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9028/1.jpg
// module id = 876
// module chunks = 0